import classNames from "classnames";
import { t } from "@/i18n-js/instance";
import { mobileCellStyles } from "@circle-react-shared/uikit/TableV2/constants";
// Columns components
import { ActionMenuColumn } from "./ActionMenuColumn";
import { AmountColumn } from "./AmountColumn";
import { CreatedAtColumn } from "./CreatedAtColumn";
import { CustomerColumn } from "./CustomerColumn";
import { PaymentMethodColumn } from "./PaymentMethodColumn";
import { PaywallColumn } from "./PaywallColumn";
import { PlatformColumn } from "./PlatformColumn";
import { StatusColumn } from "./StatusColumn";
import { TermColumn } from "./TermColumn";

const localeRoot = "settings.paywalls_admin_dashboard.charges.list.headers";

export type COLUMNS_AVAILABLE =
  | "customer"
  | "status"
  | "amount"
  | "term"
  | "paywall"
  | "platform"
  | "createdAt"
  | "actionMenu"
  | "paymentMethod";

interface CellProp {
  accessorKey: COLUMNS_AVAILABLE;
  canSort?: boolean;
  cell: any;
  cellClassName?: string;
  header: string;
  thClassName?: string;
}
type ColumnsPossibleToRenderProp = Record<COLUMNS_AVAILABLE, CellProp>;

export const orderingColumn: Record<COLUMNS_AVAILABLE, string> = {
  customer: "community_member_name",
  amount: "amount",
  paywall: "paywall_name",
  platform: "platform",
  status: "display_status",
  term: "charge_term",
  createdAt: "created_at",
  paymentMethod: "payment_method_type",
  actionMenu: "",
};

export const possibleColumnsToRender: ColumnsPossibleToRenderProp = {
  customer: {
    header: t([localeRoot, "customer_column"]),
    accessorKey: "customer",
    cell: CustomerColumn,
    thClassName: "",
    cellClassName: "",
  },
  paymentMethod: {
    header: t([localeRoot, "payment_method"]),
    accessorKey: "paymentMethod",
    cell: PaymentMethodColumn,
    thClassName: mobileCellStyles.xl,
    cellClassName: classNames(mobileCellStyles.xl, "items-center"),
    canSort: false,
  },
  term: {
    header: t([localeRoot, "term_column"]),
    accessorKey: "term",
    cell: TermColumn,
    thClassName: mobileCellStyles.lg,
    cellClassName: mobileCellStyles.lg,
  },
  amount: {
    header: t([localeRoot, "amount_column"]),
    accessorKey: "amount",
    cell: AmountColumn,
    thClassName: "",
    cellClassName: "",
  },
  status: {
    header: t([localeRoot, "status_column"]),
    accessorKey: "status",
    cell: StatusColumn,
    thClassName: "",
    cellClassName: "",
  },
  paywall: {
    header: t([localeRoot, "paywall_name_column"]),
    accessorKey: "paywall",
    cell: PaywallColumn,
    thClassName: mobileCellStyles.lg,
    cellClassName: mobileCellStyles.lg,
  },
  platform: {
    header: t([localeRoot, "platform_column"]),
    accessorKey: "platform",
    cell: PlatformColumn,
    thClassName: "",
    cellClassName: "",
  },
  createdAt: {
    header: t([localeRoot, "date_column"]),
    accessorKey: "createdAt",
    cell: CreatedAtColumn,
    thClassName: mobileCellStyles.xl,
    cellClassName: mobileCellStyles.xl,
  },
  actionMenu: {
    header: "",
    accessorKey: "actionMenu",
    cell: ActionMenuColumn,
    thClassName: "",
    cellClassName: "",
    canSort: false,
  },
};
